"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizClientFieldElement = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const typestyle_1 = require("typestyle");
const SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
const FieldFunctions_1 = require("../field/functions/FieldFunctions");
const FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
const useExpand_1 = require("./useExpand");
const ViewerPaneStyles_1 = require("./ViewerPaneStyles");
const VizClientFieldCard_1 = require("./VizClientFieldCard");
const FieldIconHeight = 17;
// this is a workaround since the shared widgets expando doesn't have a prop that allows us to right
// align the carat, note that this breaks the contract with shared widgets, so if a bug occurs as a
// result of the widget being updated, its on us to fix it
const expandoCaratRightAlignedStyle = {
    $nest: {
        '& > [role="button"]': {
            width: '100%',
        },
        '& > [role="button"] > div': {
            flexGrow: 1,
        },
        '& > [role="button"] > img': {
            order: 1,
        },
    },
};
const FieldLabel = (0, vizportalclient_common_components_1.divWithStyle)('VizClientFieldLabel', Object.assign(Object.assign({}, data_catalog_shared_1.elideTextStyle), { maxWidth: 225 }));
const FieldWrapper = (0, vizportalclient_common_components_1.divWithStyle)('VizClientFieldWrapper', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
});
const FieldCardFieldIcon = (0, vizportalclient_common_components_1.divWithStyle)('VizClientFieldCardFieldIcon', {
    flexShrink: 0,
    height: FieldIconHeight,
});
function VizClientFieldElement(props) {
    const { state: isExpanded, toggle: toggleExpando } = (0, useExpand_1.useToggle)();
    const sendDataInFieldDescriptionViewed = (0, data_catalog_shared_1.useTelemetrySender)({
        type: 'field_description_viewed',
    });
    const launchExpando = react_1.default.useCallback(() => {
        toggleExpando(true);
        sendDataInFieldDescriptionViewed({
            source: 'vizclient',
        });
    }, [toggleExpando, sendDataInFieldDescriptionViewed]);
    const isObfuscated = props.field.name === null;
    const renderIconWithFieldName = () => {
        const fieldIcon = (0, FieldFunctions_1.iconForField)(props.field);
        return (react_1.default.createElement(FieldWrapper, null,
            react_1.default.createElement(FieldCardFieldIcon, { title: fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : '' },
                react_1.default.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon })),
            react_1.default.createElement(FieldLabel, null, props.field.name)));
    };
    return (react_1.default.createElement(ViewerPaneStyles_1.SheetFieldListElementContainer, { "data-tb-test-id": 'data-details-field-element-container' }, isObfuscated
        ? (0, data_catalog_shared_1.ViewerPaneObfuscatedPlaceholder)()
        : (react_1.default.createElement(widgets_1.ExpandoWidget, { className: (0, typestyle_1.style)(expandoCaratRightAlignedStyle), direction: widgets_1.ExpandoDirection.Down, isExpanded: isExpanded, onCollapse: () => toggleExpando(false), onExpand: launchExpando, testId: 'data-details-field-element-expando', style: { display: 'block' }, label: renderIconWithFieldName() }, isExpanded
            ? (react_1.default.createElement(VizClientFieldCard_1.VizClientFieldCard, { field: props.field, workbookVizportalUrlId: props.workbookVizportalUrlId }))
            : null))));
}
exports.VizClientFieldElement = VizClientFieldElement;
//# sourceMappingURL=VizClientFieldElement.js.map